// modules
import { createAction } from 'redux-actions'

// actions
export const setPatientBillingStatistics = createAction(
  'SET_PATIENT_BILLING_STATISTICS'
)
